import { render, staticRenderFns } from "./Fulfillment.vue?vue&type=template&id=d88b5aa6&scoped=true&"
import script from "./Fulfillment.vue?vue&type=script&lang=js&"
export * from "./Fulfillment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88b5aa6",
  null
  
)

export default component.exports